import { Injectable } from '@angular/core';
import { MapPainterService } from '../map-painter/map-painter.service';
import * as d3 from 'd3';
import { DiscreteLegendComponent } from '../../discrete-legend/discrete-legend.component';
import { TimespanService } from '../timespan/timespan.service';

@Injectable({
  providedIn: 'root'
})
export class DiscreteMapPainterService extends MapPainterService {

  private discreteColors: string[] = ['#339944', '#FFCC00', '#FF8822', '#DD2233'];
   rainDivisors: {name: string, divisor: number}[] = [
    { name:'indice_pluv', divisor: 1/4},
    { name: 'quinzemin', divisor: 1/4},
    { name: 'trintamin', divisor: 1/2},
    { name: 'umahora', divisor: 1},
    { name: 'seishoras', divisor: 6},
    { name: 'dozehoras', divisor: 12},
    { name: 'vintequatrohoras', divisor: 24},
    { name: 'quarentaoitohoras', divisor: 48},
    { name: 'setentaduashoras', divisor: 72},
    { name: 'noventaseishoras', divisor: 96},
    { name: 'mes', divisor: 720}
  ]

  constructor(protected timespanService: TimespanService) { 
    super(timespanService);
  }

  /**
   * Seleciona os elementos que estão nos percentis especificados.
   * Chamado por: updateHeatMap, generateDiscreteHeatMapRain
   * 
   * @param data elementos previamente ordenados
   * @param percentil percentis que serão selecionados. Ex.: 10 para 10-percentil e 50 para a mediana
   * @returns array com os elementos do array data que estão nas posições indicadas pelo array percentil.
   */
  private createDiscreteMiddleData(data: number[], percentil: number[]): number[] {
    let middleData = [];
    const numSegments = data.length;
    for (let percent of percentil) {
      // evitando o caso do valor -1 atribuído aos pontos da borda da interpolação
      if (percent >= 0) {
        let percentVal = d3.quantileSorted(data, percent / 100);
        middleData.push(percentVal);
      }
    }
    return middleData;
  }

  /**
   * Gera uma cor discreta para o elemento (via ou ponto).
   * A lógica da escolha das cores é a seguinte:
   * - Se elem é menor que o i-ésimo valor de percentileElems, ele será associado à i-ésima cor.
   * - Se elem for maior que todos os percentileElems, ele receberá a última cor.
   * 
   * Chamado por: generateDiscreteCircleData, paintDiscreteHighwayLines.
   * 
   * @param elem valor de interesse do elemento que será colorido.
   * @param percentileElems array de valores de interesse dos elementos que estão nos percentis especificados
   * @param discreteColors array de cores discretas. Esse array tem um elemento a mais que percentileElems.
   * @returns cor discreta em hexadecimal
   */
  getColor(elem: number, compareData: number[]): string {
    let color;
    if (elem == 0) {
      return this.discreteColors[0];
    }
    else {
      let colorInd = this.discreteColors.length - 1; // começa supondo que a cor escolhida é a última
      for (let i = 0; i < compareData.length; i++) {

        if (elem < compareData[i]) {
          colorInd = i;
          break;
        }
      }
      color = this.discreteColors[colorInd];
    }
    return color;
  }

  /**
   * 
   * @param legend 
   * @param title 
   * @param compareData 
   */
  setLegend(legend: DiscreteLegendComponent, titleLines: string[], timestamp: string, compareData: number[]) {

    legend.insertText(titleLines, timestamp, compareData);
  }
}
